<template>
  <div
    v-if="applicationReady && componentReady"
    class="questionnaire"
  >
    <div class="questionnaire-top">
      <b-row>
        <b-col
          v-if="!formSubmitted"
          cols="12"
        >
          <b-row>
            <b-col
              cols="12"
              md="6"
              offset-md="3"
              class="text-center pb-4"
            >
              <h1>Covid-19 Vaccine Type</h1>
            </b-col>
          </b-row>

          <b-form>
            <b-row>
              <b-col cols="12">
                <b-form-row class="question-answer">
                  <b-col
                    cols="12"
                    md="6"
                    class="pb-3"
                    offset-md="3"
                  >
                    <b-form-select
                      size="lg"
                      v-model="formAnswers.vaccineType"
                      :options="vaccineTypes"
                      class="visitor-state"
                      :disabled="hasDeclined"
                    />
                  </b-col>
                </b-form-row>
              </b-col>
            </b-row>
          </b-form>

          <b-row>
            <b-col
              cols="12"
              md="6"
              offset-md="3"
              class="text-center pb-4"
            >
              <h1>
                Dose #1 Date
              </h1>
            </b-col>
          </b-row>

          <b-form>
            <b-row>
              <b-col cols="12">
                <b-form-row class="question-answer">
                  <b-col
                    cols="12"
                    md="6"
                    class="pb-3"
                    offset-md="3"
                  >
                    <b-form-datepicker
                      id="doseone-datepicker"
                      v-model="formAnswers.doseOneDate"
                      :disabled="hasDeclined"
                      class="mb-2"
                      :max="doseOneMaxDate"
                      :date-format-options="dateFormatOptions"
                    />
                  </b-col>
                </b-form-row>
              </b-col>
            </b-row>
          </b-form>

          <b-row>
            <b-col
              cols="12"
              md="6"
              offset-md="3"
              class="text-center pb-4"
            >
              <h1>
                Dose #1 Side Effects
              </h1>
            </b-col>
          </b-row>

          <b-form>
            <b-row>
              <b-col cols="12">
                <b-form-row class="question-answer">
                  <b-col
                    cols="12"
                    md="6"
                    class="pb-3"
                    offset-md="3"
                  >
                    <b-form-textarea
                      id="side-effects"
                      v-model="formAnswers.sideEffects"
                      :disabled="hasDeclined"
                      class="mb-2"
                    />
                  </b-col>
                </b-form-row>
              </b-col>
            </b-row>
          </b-form>

          <b-row>
            <b-col
              cols="12"
              md="6"
              offset-md="3"
              class="text-center pb-4"
            >
              <h1>
                Dose #2 Date
              </h1>
            </b-col>
          </b-row>

          <b-form>
            <b-row>
              <b-col cols="12">
                <b-form-row class="question-answer">
                  <b-col
                    cols="12"
                    md="6"
                    class="pb-3"
                    offset-md="3"
                  >
                    <b-form-datepicker
                      id="dosetwo-datepicker"
                      v-model="formAnswers.doseTwoDate"
                      :disabled="formAnswers.doseOneDate=='' || hasDeclined"
                      class="mb-2"
                      :date-format-options="dateFormatOptions"
                      :max="max"
                      :min="doseTwoMinDate"
                    />
                  </b-col>
                </b-form-row>
              </b-col>
            </b-row>
          </b-form>

          <b-row>
            <b-col
              cols="12"
              md="6"
              offset-md="3"
              class="text-center pb-4"
            >
              <h1>
                Dose #2 Side Effects
              </h1>
            </b-col>
          </b-row>

          <b-form>
            <b-row>
              <b-col cols="12">
                <b-form-row class="question-answer">
                  <b-col
                    cols="12"
                    md="6"
                    class="pb-3"
                    offset-md="3"
                  >
                    <b-form-textarea
                      id="side-effects"
                      v-model="formAnswers.sideEffectsDose2"
                      :disabled="hasDeclined"
                      class="mb-2"
                    />
                  </b-col>
                </b-form-row>
              </b-col>
            </b-row>
          </b-form>

          <b-row>
            <b-col
              cols="12"
              md="6"
              offset-md="3"
              class="text-center pb-4"
            >
              <h1>
                Declined Vaccine
              </h1>
            </b-col>
          </b-row>

          <b-form-row
            class="question-answer"
          >
            <b-col
              cols="12"
              md="6"
              class="pb-3"
              offset-md="3"
            >
              <b-form-row class="question-checkboxes">
                <b-col
                  cols="12"
                  md="6"
                  offset-md="3"
                  class="text-center pb-4"
                >
                  <b-form-checkbox
                    class="question-checkbox"
                    size="lg"
                    v-model="formAnswers.declined"
                    text-field="answer_text"
                    value-field="answer_value"
                  >
                    Yes
                  </b-form-checkbox>
                </b-col>
              </b-form-row>
            </b-col>
          </b-form-row>
          <!--
          <b-form-row
            class="question-answer"
          >
            <b-col
              cols="12"
              md="6"
              class="pb-3"
              offset-md="3"
            >
              <b-form-row class="question-checkboxes">
                <b-col
                  v-for="value in declinedQuestion.values"
                  :key="value.id"
                  cols="12"
                  md="6"
                  class="pb-3 px-4"
                >
                  <b-form-checkbox
                    class="question-checkbox"
                    size="lg"
                    v-model="formAnswers.declinedVaccine[value.id]"
                    :disabled="checkboxDisabledState[declinedQuestion.id][value.id]"
                    text-field="answer_text"
                    value-field="answer_value"
                  >
                    {{ value.answer_text }}
                  </b-form-checkbox>
                </b-col>
              </b-form-row>
            </b-col>
          </b-form-row>
          -->

        </b-col>
      </b-row>

      <b-row>
        <b-col
          v-if="formSubmitted"
          cols="12"
          class="screening-complete"
        >
          <b-row>
            <b-col
              cols="12"
              class="screening-complete-title"
            >
              <span class="success-message exit">
                <h1>
                  Screening Complete!
                </h1>
              </span>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>

    <div class="questionnaire-bottom">
      <b-row>
        <b-col cols="12">
          <b-form>
            <b-form-row class="justify-content-center no-gutters">
              <b-col
                v-if="!formSubmitted"
                cols="6"
                sm="4"
                class="pb-3 question-navigation order-md-2"
              >
              </b-col>

              <b-col
                v-if="!formSubmitted"
                cols="6"
                sm="4"
                class="pb-3 question-navigation order-md-3"
              >
                <b-button
                  @click.stop.prevent="submitForm"
                  class="btn-green btn-nav"
                >
                  Submit
                </b-button>
              </b-col>

              <b-col
                v-if="!formSubmitted"
                cols="6"
                sm="4"
                class="pb-3 question-navigation order-md-1"
              >
                <b-button
                  @click="goHome"
                  class="btn-green btn-nav"
                >
                  <img
                    src="../assets/home-icon.png"
                  >
                </b-button>
              </b-col>

              <b-col
                v-if="formSubmitted"
                cols="6"
                sm="4"
                class="pb-3 question-navigation order-md-2"
              >
                <b-button
                  @click="goHome"
                  class="btn-green btn-nav"
                >
                  <img
                    src="../assets/home-icon.png"
                    class="screening-icon"
                  >
                </b-button>
              </b-col>

              <b-col
                v-if="formSubmitted"
                cols="6"
                sm="4"
                class="pb-3 question-navigation order-md-2"
              >
                <b-button
                  @click="logout"
                  class="btn-green btn-nav"
                >
                  <img
                    src="../assets/log-out-icon-white.png"
                    class="icon-with-text"
                  >
                  Log out
                </b-button>
              </b-col>
            </b-form-row>
          </b-form>
        </b-col>
      </b-row>
    </div>

    <b-modal
      v-model="missing_data"
      id="failed-screening"
      modal-class="failed-screening"
      centered
      no-close-on-esc
      hide-header
      hide-footer
    >
      <p class="my-4 text-center">
        You must enter a Dose One Date and Vaccine Type or select "Declined Vaccine"
      </p>

      <b-row>
        <b-col
          cols="12"
          class="pb-3 text-left"
        >
          <b-button
            variant="green"
            class="failed-screening-option"
            @click.stop.prevent="hideWarning"
          >
            OK
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
// import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import mixin from '../mixins/forms.js'
import moment from 'moment'

export default {
  middleware: 'auth',
  name: 'VaccineTracking',
  mixins: [mixin],
  data () {
    return {
      missing_data: false,
      formAnswers: {
        doseOneDate: '',
        doseTwoDate: '',
        sideEffects: '',
        sideEffectsDose2: '',
        // declinedVaccine: [],
        declined: false,
        vaccineType: null
      }
    }
  },
  mounted () {
    this.init()
    this.formAnswers.vaccineType = this.vaccineType
    if (this.vaccineTracking !== null) {
      this.formAnswers.doseOneDate = (this.vaccineTracking.first_dose_date === '0000-00-00') ? '' : this.vaccineTracking.first_dose_date
      this.formAnswers.doseTwoDate = (this.vaccineTracking.second_dose_date === '0000-00-00') ? '' : this.vaccineTracking.second_dose_date
      this.formAnswers.sideEffects = (this.vaccineTracking.side_effects === '') ? '' : this.vaccineTracking.side_effects
      this.formAnswers.sideEffectsDose2 = (this.vaccineTracking.side_effects_dose_2 === '') ? '' : this.vaccineTracking.side_effects_dose_2
      this.formAnswers.declined = (this.vaccineTracking.declined === 1)
      this.formAnswers.vaccineType = this.vaccineTracking.vaccine_type
    }
    /*
    const noValue = this.declinedQuestion.values.filter(dq => dq.answer_text === 'No')[0]
    const yesValue = this.declinedQuestion.values.filter(dq => dq.answer_text === 'Yes')[0]
    if (this.vaccineTracking.declined === 1) {
      this.declinedVaccine[yesValue.id] = true
      this.declinedVaccine[noValue.id] = false
      this.checkboxDisabledState[this.declinedQuestion.id][yesValue.id] = false
      this.checkboxDisabledState[this.declinedQuestion.id][noValue.id] = true
    } else {
      this.declinedVaccine[yesValue.id] = false
      this.declinedVaccine[noValue.id] = true
      this.checkboxDisabledState[this.declinedQuestion.id][yesValue.id] = true
      this.checkboxDisabledState[this.declinedQuestion.id][noValue.id] = false
    }
    */
  },
  computed: {
    ...mapGetters([
      'vaccineTracking',
      'vaccineType'
    ]),
    componentReady () {
      if (this.loggedIn) {
        return this.currentQuestionnaire !== undefined && this.questions !== undefined && this.questionAnswersAndStatesSetup
      }
      return false
    },
    declinedVaccine () {
      return this.formAnswers.declinedVaccine
    },
    declinedQuestion () {
      return this.currentQuestionnaire.questions.filter(qq => qq.section === 'declinedVaccine')[0]
    },
    vaccineTypes () {
      if (this.currentQuestionnaire !== null) {
        const rtypes = [{ value: 0, text: 'Please Select', disabled: true }]
        const vquestion = this.currentQuestionnaire.questions.filter(qq => qq.section === 'vaccineType')[0]
        for (const t in vquestion.values) {
          const vtype = vquestion.values[t]
          const tmp = { value: vtype.answer_value, text: vtype.answer_text, disabled: false }
          rtypes.push(tmp)
        }
        return rtypes
      }
      return []
    },
    hasDeclined () {
      return this.formAnswers.declined
      // const yesValue = this.declinedQuestion.values.filter(dq => dq.answer_text === 'Yes')[0]
      // return this.declinedVaccine[yesValue.id]
    },
    doseTwoMinDate () {
      if (this.formAnswers.doseOneDate === '') {
        return null
      }

      return moment(this.formAnswers.doseOneDate).add(1, 'days').format('YYYY-MM-DD')
    },
    doseOneMaxDate () {
      if (this.formAnswers.doseTwoDate === '') {
        return moment().format('YYYY-MM-DD')
      }

      return moment(this.formAnswers.doseTwoDate).subtract(1, 'days').format('YYYY-MM-DD')
    }
  },
  /*
  watch: {
    declinedVaccine: {
      handler: function (newAnswers, oldAnswers) {
        const values = this.declinedQuestion.values
        const noValue = values.find(value => value.answer_text.toLowerCase() === 'no')
        const yesValue = values.find(value => value.answer_text.toLowerCase() === 'yes')
        let noDisabled = false
        let yesDisabled = false
        newAnswers.forEach((isChecked, key) => {
          const value = values.find(value => value.id === key)
          if (this.isNoOption(value)) {
            yesDisabled = isChecked
          } else {
            noDisabled = isChecked
          }
          return true
        })

        this.checkboxDisabledState[this.declinedQuestion.id][noValue.id] = noDisabled
        this.checkboxDisabledState[this.declinedQuestion.id][yesValue.id] = yesDisabled
      },
      deep: true
    }
  },
  */
  methods: {
    async init () {
      await this.setCurrentPage(1)
      await this.isSingleStep()
    },
    submitForm () {
      if ((this.formAnswers.doseOneDate === null || this.formAnswers.doseOneDate.trim() === '' || this.formAnswers.vaccineType === null) && this.formAnswers.declined === false) {
        console.log('missing data')
        this.missing_data = true
      } else {
        // this.formAnswers.declined = this.hasDeclined
        console.log('submitting form')
        this.missing_data = false
        this.setFormSubmitted(!this.formSubmitted)
        this.submitVaccineData(this.formAnswers)
      }
    },
    hideWarning () {
      this.missing_data = false
    }
  }
}
</script>

<style scoped lang="scss">
  .questionnaire-bottom {
    text-align: center;
  }
</style>
